

const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect


export function aswoToModelVariant(aswo) {
    const modelVariant = {}
    modelVariant.modelId = aswo.Geraeteid
    modelVariant.model = aswo.Type
    modelVariant.variant = aswo.Identnummer
    modelVariant.variantId = aswo.Identnummer
    modelVariant.brand = aswo.Hersteller
    modelVariant.type = aswo.Geraeteart
    modelVariant.totalResults = aswo.Artikelanzahl
    modelVariant.files = []
    modelVariant.supplier = ASWOProvider
    modelVariant.supplierName = ASWOProvider.name
    return modelVariant

}

export function connectToModelVariant(connect) {

    const modelVariant = {}
    modelVariant.modelId = connect.modelId.toString()
    modelVariant.model = connect.model
    modelVariant.variant = connect.serialNo
    modelVariant.variantId = connect.variantId.toString()
    modelVariant.brand = connect.brand
    modelVariant.type = connect.appliance
    modelVariant.totalResults = connect.totalItems !== undefined ? connect.totalItems : '0'
    // modelVariant.files = connect.illustrations != undefined ? illustrationsToFiles(connect.illustrations) : []
    modelVariant.supplier = ConnectProvider
    modelVariant.supplierName = ConnectProvider.name
    return modelVariant

}

export function illustrationsToFiles(illustrations) {
    // console.log(illustrations);
    const files = []
    illustrations.forEach(illustration => {
        const file = {}
        file.url = illustration.illustrationUrl
        file.title = illustration.illustrationTitle
        file.type = illustration.illustrationType
        file.illustrationImage = illustration.illustrationUrl
        file.supplierName = ConnectProvider.name
        files.push(file)
    });
    return files
}